import React, { Component } from 'react';
import { STYLES } from 'core/constants/uiConstants';
import { withPCTranslation } from 'core/hocs';

export const formatValue = (n) => {
  return n ? "$" + n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") : "";
};

class PremiumDisplay extends Component {
  coverageItemsDisplay = (msg_basepremium, policyVal) => {
    const { insuranceData, t } = this.props;
    const {
      propStyle: { summary, coveragetype, coveragevalue },
      stateData,
    } = this.props;
    if (Object.keys(insuranceData).length > 0 && !stateData["numErrors"] > 0) {
      const termsKeyArr = [];
      const benefitsKeyArr = [];
      for (let key in insuranceData.coverageListItems) {
        if (key.includes("Term")) {
          termsKeyArr.push(key);
        } else {
          benefitsKeyArr.push(key);
        }
      }
      const keyArr = [...termsKeyArr, 'memberBenefit', ...benefitsKeyArr]; //merging 2 arrays by keeping terms first and then benefits
      return keyArr.map((key) => {

        if(key === 'memberBenefit'){
          return <div
            className={`${STYLES.BASIC} ${STYLES.SUMMARY} ${summary} paddingMedLeftIndent`}
            key={key}
          >
            <div className={`${STYLES.COVERAGETYPE} ${coveragetype}`}>
              {t('msg-memberBenefit')}
            </div>
            <div
              className={`${STYLES.COVERAGEVALUE} ${coveragevalue} evenLetterSpacing`}
            >
              {"$0.00"}
            </div>
          </div>
        }
        return (
          <div
            className={`${STYLES.BASIC} ${STYLES.SUMMARY} ${summary} ${
              key.includes("Term") ? "" : "paddingMedLeftIndent"
            }`}
            key={insuranceData.coverageListItems[key].name}
          >
            <div className={`${STYLES.COVERAGETYPE} ${coveragetype}`}>
              {key.includes("Term")
                ? msg_basepremium
                : t(insuranceData.coverageListItems[key].coverageType)}
            </div>
            <div
              className={`${STYLES.COVERAGEVALUE} ${coveragevalue} evenLetterSpacing`}
            >
              {key.includes("Term")
                ? formatValue(
                    policyVal +
                      insuranceData.coverageListItems[key].modalPremium
                  )
                : formatValue(
                    insuranceData.coverageListItems[key].modalPremium
                  )}
            </div>
          </div>
        );
      });
    }
    return null;
  };

  render() {
    const { insuranceData } = this.props;
    //let msg_premiumsummary = this.props.t('msg-PremiumSummary');
    let msg_basepremium = this.props.t("msg-BasePremium");
    let msg_policyfee = this.props.t("msg-PolicyFee");
    let msg_annualpremium = this.props.t('msg-AnnualPremium');


    let msg_nodata = this.props.t("msg-NoData");
    let msg_notApplicable = this.props.t("msg-NotApplicable");
    const {
      propStyle: { container, header, summary, coveragetype, coveragevalue },
      stateData,
    } = this.props;

    if (Object.keys(insuranceData).length === 0) {
      return (
        <div
          className={`${STYLES.BASIC} ${STYLES.HEADER} ${header} paddingMedWide`}
        >
          {msg_nodata}
        </div>
      );
    } else {
      //const errors = this.props.stateData['numErrors'] == 0;
      if (
        this.props.stateData["numErrors"] > 0 ||
        insuranceData.jointAgeError
      ) {
        return (
          <div
            className={`${STYLES.BASIC} ${STYLES.PREMIUMDISPLAY} ${container}`}
          >
            {/* <div className={`${STYLES.BASIC} ${STYLES.HEADER} ${header}`}>
              {msg_premiumsummary}
            </div> */}
            <div className={`${STYLES.BASIC} ${STYLES.SUMMARY} ${summary}`}>
              {msg_notApplicable}
            </div>
          </div>
        );
      } else {
        return (
          <div
            className={`${STYLES.BASIC} ${STYLES.PREMIUMDISPLAY} ${container}`}
          >
            {/* <div className={`${STYLES.BASIC} ${STYLES.HEADER} ${header}`}>
              {msg_premiumsummary}
            </div> */}

            <div className={`${STYLES.SUMMARYCONTAINER}`}>
              <div
                className={`${STYLES.BASIC} ${STYLES.SUMMARY} ${summary}`}
                style={{
                  display:
                    this.props.stateData["cboProduct"] === "0180"
                      ? "none"
                      : "flex",
                }}
              >
                <div className="base-premium">
                  {this.props.stateData["cboProduct"] === "0180"
                    ? msg_policyfee
                    : msg_basepremium}
                </div>
                <div
                  id="base-premium-value"
                  className="base-premium-value evenLetterSpacing"
                >
                  {formatValue(this.getInitialPremiumByID("001"))}
                </div>
              </div>

              {this.coverageItemsDisplay(
                msg_basepremium,
                this.getInitialPremiumByID("001")
              )}

              <div
                className={`${STYLES.BASIC} ${STYLES.SUMMARY} ${summary} fontBold`}
              >
                <div className="annual-premium fontBold">
                  {msg_annualpremium}
                </div>
                <div
                  id="annual-premium-value"
                  className="annual-premium-value evenLetterSpacing fontBold"
                >
                  {formatValue(this.getInitialCalcValueByName("AnnualPremium"))}
                </div>
              </div>
            </div>
          </div>
        );
      }
    }
  }

  getInitialPremiumByID(strCoverageID) {
    if (!this.props.insuranceData) {
      return 0;
    }
    for (let columnItem of this.props.insuranceData.columnItems) {
      if (columnItem.name === "ModalPremium_" + strCoverageID) {
        //console.log("FOUND");
        //Object.keys(aColumnItem).map(i => console.log(`${i} = ${aColumnItem[i]}`));
        //console.log(this.props.insuranceData.dblTableData_Main[1][aColumnItem.columnNumber]);
        return this.props.insuranceData.dblTableData_Main[1][
          columnItem.columnNumber
        ];
      }
    }

    return 0;
  }

  getInitialPremiumByName(strName) {
    for (let columnItem of this.props.insuranceData.columnItems) {
      if (columnItem.name === strName) {
        //console.log("FOUND");
        return this.getInitialPremiumByID(columnItem.coverageID);
      }
    }

    return 0;
  }

  getInitialCalcValueByName(strName) {
    for (let columnItem of this.props.insuranceData.columnItems) {
      if (columnItem.name === strName) {
        //console.log("FOUND");
        return this.props.insuranceData.dblTableData_Main[1][
          columnItem.columnNumber
        ];
      }
    }

    return 0;
  }
}

export default withPCTranslation(PremiumDisplay);
